/** See `src/i18n/locales/en/communications.ts`. */
export const communications = {
  page: {
    title: 'Communication',
    lead: 'Rédigez et planifiez des notifications pour {{company}}.',
    noScope: 'Sélectionnez une entreprise pour voir sa communication.',
    forbidden: "Vous n'êtes pas autorisé à voir la communication de cette entreprise.",
  },
  composer: {
    title: 'Nouvelle notification',
    titleField: 'Titre',
    message: 'Message',
    category: 'Catégorie',
    audience: 'Public cible',
    date: 'Date',
    time: 'Heure',
    callToAction: "Appel à l'action",
    quietHours: 'Respecter les heures calmes',
    quietHoursHint: 'Retarder la livraison en dehors de 08:00–20:00.',
    submit: 'Enregistrer comme brouillon',
    schedule: 'Planifier',
    send: 'Envoyer maintenant',
  },
  categories: {
    algemeen: 'Général',
    veiligheid: 'Sécurité',
    evenement: 'Événement',
    vitaliteit: 'Vitalité',
    hr: 'RH',
  },
  audiences: {
    iedereen: 'Tout le monde',
    management: 'Direction',
    per_afdeling: 'Par département',
    per_locatie: 'Par site',
  },
  status: {
    concept: 'Brouillon',
    ingepland: 'Planifié',
    verzonden: 'Envoyé',
  },
  log: {
    title: "Journal d'envoi",
    empty: 'Pas encore de communication.',
    columns: {
      message: 'Message',
      category: 'Catégorie',
      reach: 'Portée',
      openRate: "Taux d'ouverture",
      status: 'Statut',
    },
  },
  actions: {
    new: 'Nouvelle notification',
    cancel: 'Annuler',
    markScheduled: 'Marquer comme planifié',
    markSent: 'Marquer comme envoyé',
  },
} as const;
